// extracted by mini-css-extract-plugin
export default {"container":"YnZIfN","title":"oC6KPY","subtitle":"aiGUxU","textSecondary":"w3AMsU","progressBarWrapper":"Jz9T01","loadingDots":"YNnvLU","dot":"cfK8_w","dotPulse":"PPnMlq"};